// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2NHQi","range":"MonthRangeSwitch_range__19Dft","disabled":"MonthRangeSwitch_disabled__1p91v"};